<template>
  <div class="header">
    <div class="container-fluid mt-4">
      <div class="card">
        <!-- Image -->
        <img src="../../assets/img/covers/profile-cover-1.jpg" class="card-img-top" />

        <!-- Body -->
        <div class="card-body">
          <!-- Image -->
          <a class="avatar avatar-xl card-avatar card-avatar-top">
            <img src="../../assets/img/avatars/profiles/users_1.png"
              class="avatar-img rounded-circle border border-4 border-card" />
          </a>

          <!-- Heading -->
          <h2 class="card-title text-center">
            <p>{{ aboutMe.fullname }}</p>
          </h2>

          <!-- Text -->
          <p class="small text-muted mb-3 text-center">
            {{ aboutMe.roles }}
          </p>

          <!-- Badges -->
          <p class="card-text">
            <span class="badge bg-secondary-soft mr-2">
              <!-- Department of {{ profile.department }} -->
            </span>
            <span class="badge bg-secondary-soft">
              <!-- Position as {{ profile.position }} -->
            </span>
          </p>

          <b-tabs content-class="mt-3">
            <b-tab title="Activity Log" active>
              <div class="row mb-3">
                <div class="col-lg-3">
                  Activity:
                  <v-select :options="options" v-model="body.type" :reduce="(e) => e.value" label="label"
                    @input="getActivity()"></v-select>

                </div>
              </div>
              <div v-if="isLoading == true">
                <div class="list-group list-group-flush list-group-activity my-n3"
                  style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
                  <div class="list-group-item">
                    <div class="row">
                      <div class="col-auto">

                        <!-- Avatar -->
                        <div class="avatar avatar-sm">

                          <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                            <i class="fe fe-activity"></i>
                          </div>
                        </div>

                      </div>
                      <div class="col ms-n2">

                        <!-- Heading -->
                        <h5 class="mb-1">
                          <b-skeleton animation="wave" width="20%"></b-skeleton>
                        </h5>

                        <!-- Text -->
                        <b-skeleton animation="wave" width="40%"></b-skeleton>
                        <b-skeleton animation="wave" width="15%"></b-skeleton>

                        <!-- Time -->
                        <b-skeleton animation="wave" width="12%"></b-skeleton>

                      </div>
                    </div> <!-- / .row -->
                  </div>
                </div>
              </div>
              <div v-if="isLoading == false">
                <div v-if="activity.data.length > 0" class="list-group list-group-flush list-group-activity my-n3"
                  style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
                  <div class="list-group-item" v-for="(item, index) in activity.data" :key="index">
                    <div class="row">
                      <div class="col-auto">

                        <!-- Avatar -->
                        <div class="avatar avatar-sm">

                          <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                            <i class="fe fe-activity"></i>
                          </div>
                        </div>

                      </div>
                      <div class="col ms-n2">

                        <!-- Heading -->
                        <h5 class="mb-1">
                          <b>{{ item.action }}</b>
                        </h5>

                        <!-- Text -->
                        <p class="small text-gray-700 mb-0">
                          {{ item.details }}
                        </p>
                        <p class="small text-gray-700 mb-0">
                          {{ item.employee_name }}
                        </p>

                        <!-- Time -->
                        <small class="text-body-secondary">
                          {{ times(item.created_at) }}
                        </small>

                      </div>
                    </div> <!-- / .row -->
                  </div>
                </div>
                <div v-else class="alert bg-primary-soft">
                  No Activity Found
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import moment from "moment";

  export default {
    name: "trainingMethod",
    computed: {
      activity() {
        return this.$store.getters["dashboard/activity"];
      },
      aboutMe() {
        return this.$store.getters["users/profiles"];
      }
    },
    data() {
      return {
        body: {
          type: '',
        },
        options: [
          {
            label: 'Structured Learning',
            value: 'structured'
          },
          {
            label: 'Social Learning',
            value: 'social'
          },
          {
            label: 'Experiential  Learning',
            value: 'experential'
          }
        ],
        isLoading: false
      };
    },
    mounted() {
      // if (this.role && this.role.length < 1) {
      this.getActivity();
      // }
    },
    methods: {
      //action
      times(dat) {
        return moment(dat).fromNow();
      },
      // api hit
      getActivity() {
        this.isLoading = true
        this.$store.dispatch("dashboard/getActivityLog", this.body).then((resp) => {
          this.isLoading = false
        })
      },
    }
  };
</script>